module.exports = __webpack_public_path__ + "media/images/ecute/ecutetokyo_en-66031da5baaf8cb21f8cd4c71d804094.jpg";